<div class="forgot-password">
  <h2 class="forgot-password__heading">{{ content?.fields.heading }}</h2>
  <p class="forgot-password__ingress">{{ content?.fields.subheading }}</p>
  <form [formGroup]="form" (ngSubmit)="resetPassword()">
    <div class="forgot-password-form__input-container">
      <input
        class="forgot-password-form__input"
        type="email"
        name="email"
        formControlName="email"
        [placeholder]="content?.fields.emailLabel"
      />
      <span
        class="forgot-password-form__input-error"
        *ngIf="hasError(email, 'required')"
      >
        {{ globalContent?.fields.inputValidationRequired }}
      </span>
      <span
        class="forgot-password-form__input-error"
        *ngIf="hasError(email, 'email')"
      >
        {{ globalContent?.fields.inputValidationInvalidEmail }}
      </span>
    </div>

    <div class="forgot-password-form-submit">
      <button class="forgot-password-form-submit__button" [disabled]="loading" type="submit">
        <span *ngIf="loading; else submitText">Sending...</span>
        <ng-template #submitText>{{ content?.fields.ctaText }}</ng-template>
      </button>
    </div>

    <p class="forgot-password__ingress" *ngIf="success">
      {{ globalContent?.fields.forgotPasswordSuccessMessage }}
    </p>
  </form>
</div>
